import React, {memo} from 'react';

interface ConfusionMatrixCellProps {
    count: number;
    percentage?: number;
    showPercentages: boolean;
    isHighlighted: boolean;
    correct?: boolean;
    onMouseEnter: () => void;
}

function ConfusionMatrixCell({
    count,
    percentage,
    showPercentages,
    isHighlighted,
    correct,
    onMouseEnter,
}: ConfusionMatrixCellProps): JSX.Element {
    return (
        <div
            className={`c-confusionMatrix__cell ${count > 0 ? 'c-confusionMatrix__cell--hasValue' : ''} ${
                isHighlighted ? 'c-confusionMatrix__cell--highlighted' : ''
            } ${correct === true ? 'c-confusionMatrix__cell--correct' : ''} ${
                correct === false && count > 0 ? 'c-confusionMatrix__cell--incorrect' : ''
            }`}
            onMouseEnter={onMouseEnter}
        >
            {count}
            {showPercentages && !!percentage && percentage > 0 && <div className="c-confusionMatrix__percentage">({percentage}%)</div>}
        </div>
    );
}

export default memo(ConfusionMatrixCell);
